// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pm-0";